import { useCallback, useState, useEffect } from 'react';
import { VIEWS_TYPES } from '../colorPickerUtils';

export const useToggleView = (initialState, alpha) => {
  const [currentView, setCurrentView] = useState(initialState);
  const handleSwitchView = useCallback(() => {
    if (currentView === VIEWS_TYPES.HEX) {
      setCurrentView(VIEWS_TYPES.RGB);
    } else if (currentView === VIEWS_TYPES.RGB) {
      setCurrentView(VIEWS_TYPES.HSL);
    } else {
      if (alpha === 1) {
        setCurrentView(VIEWS_TYPES.HEX);
      } else {
        setCurrentView(VIEWS_TYPES.RGB);
      }
    }
  }, [alpha, currentView]);
  useEffect(() => {
    if (alpha !== 1 && currentView === VIEWS_TYPES.HEX) {
      setCurrentView(VIEWS_TYPES.RGB);
    }
  }, [alpha, currentView, handleSwitchView]);
  return {
    currentView,
    handleSwitchView,
  };
};
